import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import {Box, Button, IconButton, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {AlarmModuleNode} from '../../interfaces/AlarmModuleNode';
import {MapLatLangCoordinates} from '../common/Map';
import ModalDraggable from '../common/ModalDraggable';
import AlarmAcknowledge from './AlarmAcknowledge';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  item: AlarmModuleNode;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  locationCoordinates?: MapLatLangCoordinates;
  onSubmitted?: (item: AlarmModuleNode) => void;
}

const AlarmAcknowledgeButton = <T extends ComponentType>({
  component,
  componentProps,
  children,
  locationCoordinates,
  onSubmitted,
  ...props
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Acknowledge">
        <Component {...componentProps} onClick={() => setIsOpened(true)}>
          {children}
        </Component>
      </Tooltip>

      {isOpened ? (
        <ModalDraggable open={isOpened}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box
                className="dragHandle"
                display="flex"
                alignItems="center"
                width="100%"
                gap={1.5}
              >
                <EditIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Acknowledge Alarm</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <AlarmAcknowledge
              {...props}
              locationCoordinates={locationCoordinates}
              onSubmitted={(item) => {
                onSubmitted?.(item);
                setIsOpened(false);
              }}
              onCancel={() => setIsOpened(false)}
            />
          </Box>
        </ModalDraggable>
      ) : null}
    </>
  );
};

export default AlarmAcknowledgeButton;
